(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('signoffcounter', {
      restrict: 'E',
      bindings: {
        patientid: '<?'
      },
      template: `
        <span class="badge badge-error"  data-hook="signoffcounter" ng-bind="vm.counter" uib-tooltip="Dokumente zu vidieren" tooltip-placement="auto"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, File, Rlog, vertxEventBusService, $http) {
          let vm = this;


          const getCounter = function (patid) {
            let lpatid = patid || undefined;
            let query = [{
              $match: {
                scanstatus: 'assigned',
                active: true
              }
            }, {
              $group: {
                _id: null,
                counter: {$sum: 1}
              }
            }];

            if (angular.isDefined(lpatid)) {
              query[0].$match.patientid = lpatid;
            }

            $http.post('/routes/files/aggregate', query).then(res => {
              vm.counter = 0;
              if (res.data.counter) {
                vm.counter = res.data.counter;
                $log.debug('refreshed signoffcounter: ', vm.counter);
              }
            }, err => {
              Rlog.error('dms.scan', 'signoffcounter', 'signoffcounter.$aggregate failed', {});
              $log.error('signoffcounter.$aggregate failed', err);
            });
          };

          const getComplexCounter =  function (message) {
            $log.debug('signoffcounter scanfile.update msg caught, refreshing: ', message);
            if (angular.isDefined(vm.patientid)) {
              getCounter(vm.patientid);
            } else {
              getCounter();
            }
          };

          vm.$onInit = function () {
            if (angular.isUndefined(vm.patientid)) {
              getCounter();
            }

            // listen for updates
            vertxEventBusService.on('scanfile.update', {}, getComplexCounter);
            vertxEventBusService.on('files.update', {}, getComplexCounter);
            vertxEventBusService.on('files.create', {}, getComplexCounter);
          }; // $onInit()


          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue)) {
              vm.patientid = changes.patientid.currentValue;
              getCounter(vm.patientid);
            }
          }; // $onInit()




          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('files.update', {}, getComplexCounter);
            vertxEventBusService.unregisterHandler('scanfile.update', {}, getComplexCounter);
            vertxEventBusService.unregisterHandler('files.create', {}, getComplexCounter);
          };




        }
      ] // controller
    }); // component

// klammerfriedhof
}());
